module.exports = __webpack_public_path__ + "img/frontdoor-full.0cc8e69c.jpg";